import { createContext } from 'react';
import { User } from './AuthApi/authApi.constants';

interface AppContextInterface {
  user: User;
  login: () => Promise<void>;
  logout: () => Promise<void>;
}

export const AuthContext = createContext<AppContextInterface>({} as AppContextInterface);
